export enum ApiFormat {
    JSON = 'JSON',
    FORM = 'FORM',
    MULTIPART = 'MULTIPART',
    TEXT = 'TEXT'
}
